import { observer } from "mobx-react-lite";
import { useContext, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import ConfirmPresentationOpen from "./ConfirmPresentationOpen";
import DocumentPinForm from "./DocumentPinForm";
import ScreencCodeForm from "./ScreenCodeForm";
import { RemovelauncherGuestScreenLocalSession } from "../../app/helpers/urlHelper";
import ScreenCodeForm from "./ScreenCodeForm";

interface IParams {
  zone: string;
}

const ScreenCodePage: React.FC<IParams> = ({ zone }) => {
  const rootStore = useContext(RootStoreContext);
  const { pinValidated } = rootStore.guestStore;

  const handleResize = () => {
    let responsivePaddingTop = document.documentElement.clientHeight * 0.05;
    document.body.style.paddingTop = `${responsivePaddingTop}px`;
  };

  useEffect(() => {
    let responsivePaddingTop = document.documentElement.clientHeight * 0.05;
    window.addEventListener("resize", handleResize);
    document.body.classList.add("form-membership");
    document.body.style.paddingTop = `${responsivePaddingTop}px`;
    RemovelauncherGuestScreenLocalSession();
    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.classList.remove("form-membership");
      document.body.style.paddingTop = "";
    };
  }, []);

  return (
    <>
      <Container>
        <Row>
          <Col />
          <Col lg="8">
            <Row className="justify-content-center">
            <ScreenCodeForm></ScreenCodeForm>
            </Row>
          </Col>
          <Col />
        </Row>
      </Container>
    </>
  );
};

export default observer(ScreenCodePage);
